
import PageContainer from '@/components/ui/containers/PageContainer'
import SubscribePlaceholder from './component/SubscribePlaceholder'

export default function SubscribePage() {
  return (
    <PageContainer>
      <SubscribePlaceholder />

    </PageContainer>
  )
}
